import { render, staticRenderFns } from "./ImportarModalVerDetalle.vue?vue&type=template&id=3d5daa17&"
import script from "./ImportarModalVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./ImportarModalVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./ImportarModalVerDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3d5daa17', component.options)
    } else {
      api.reload('3d5daa17', component.options)
    }
    module.hot.accept("./ImportarModalVerDetalle.vue?vue&type=template&id=3d5daa17&", function () {
      api.rerender('3d5daa17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/ImportarModalVerDetalle.vue"
export default component.exports